import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-primary-diagnosis-edit-modal',
  templateUrl: './primary-diagnosis-edit-modal.component.html',
  styleUrls: ['./primary-diagnosis-edit-modal.component.css']
})
export class PrimaryDiagnosisEditModalComponent implements OnInit {
  @Input() primaryDiagnosis: any;
  @Output() onCloseModal = new EventEmitter<string>();
  @Output() onSave = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  onSavePrimaryDiagnosis(evt: any) {
    this.onSave.emit(evt);
  }

  closeModal() {
    this.onCloseModal.emit();
  }
}
